import { useRef } from 'react'

import { NEWSBOARD_ENTITY } from '../../../../constants/entity'
import { usePageBrowserTabTitle } from '../../../../hooks'
import { useAsyncListLoader } from '../../../AsyncList'
import { getPosts } from '../../Post.api'
import { POST_LIST_API_PARAMS } from '../../Post.constants'
import {
  checkPostListIsLastPage,
  getNextFilterParamsFromPostListItems,
  getPostListItemsData,
} from '../../Post.utils'

export function usePostListPage({
  asyncListOptions,
  entity = NEWSBOARD_ENTITY,
  getDataItems = getPostListItemsData,
  getPermanentFilters,
  listFilters,
  listPreloader,
  pageTitle,
  sub,
  onChangeInitialized,
  onChangePermissions,
  onFilterItems,
}) {
  const pageScrollWrapperRef = useRef(null)

  const asyncList = useAsyncListLoader({
    ...asyncListOptions,
    apiParams: POST_LIST_API_PARAMS,
    checkIsLastPage: checkPostListIsLastPage,
    entity,
    getData: getPosts,
    getDataItems,
    getNextItems: getNextFilterParamsFromPostListItems,
    getPermanentFilters,
    listFilters,
    listPreloader,
    sub,
    onChangeInitialized,
    onChangePermissions,
    onFilterItems,
  })

  usePageBrowserTabTitle({
    isLoading: asyncList.loadingInitial,
    pageTitle,
  })

  return {
    ...asyncList,
    pageScrollWrapperRef,
  }
}
